import { NavigateFunction } from "react-router-dom";
import { LOCAL, PRODUCTION, isDevRuntime } from "../config/urls";

export type UserRole = "admin" | "user";

export type User = {
  role?: UserRole | string;
  userRole?: UserRole | string;
  user_role?: UserRole | string;
  email?: string;
  [key: string]: any;
};

export function determineUserRole(user: User): UserRole {
  const r = (user?.role ?? user?.userRole ?? user?.user_role ?? "user").toString().toLowerCase();
  return r === "admin" ? "admin" : "user";
}

/**
 * Resolves REACT_APP_ADMIN_URL for a full-page redirect to the qfo-admin app.
 * Trims whitespace, adds http(s) if missing, and fails with a clear message on bad values.
 */
export function resolveAdminAppUrl(): string {
  const raw = process.env.REACT_APP_ADMIN_URL?.trim() ?? "";
  if (!raw) {
    if (isDevRuntime()) {
      return LOCAL.ADMIN_APP_PATH;
    }
    return PRODUCTION.ADMIN_APP_PATH;
  }
  const withScheme = /^[a-zA-Z][a-zA-Z+\-.]*:\/\//.test(raw) ? raw : `http://${raw}`;
  try {
    return new URL(withScheme).toString();
  } catch {
    throw new Error(
      `REACT_APP_ADMIN_URL is not a valid URL: "${raw}". Use an absolute URL like ${PRODUCTION.ADMIN_APP_PATH}`
    );
  }
}

function getMyAppDashboardUrl(): string {
  // Default to projects dashboard root
  //const envUrl = process.env.REACT_APP_USER_DASHBOARD_URL;
  //if (!envUrl) {
   // throw new Error('REACT_APP_ADMIN_URL is not defined');
  //}
  const envUrl = "/";
  return envUrl;
}

export function handleRoleBasedRedirect(user: User, navigate: NavigateFunction) {
  const role = determineUserRole(user);
  if (role === "admin") {
    const adminBase = resolveAdminAppUrl();
    const token = localStorage.getItem("token") || "";
    const url = new URL(adminBase);
    if (token) {
      url.searchParams.set("token", token);
    }
    // Full page redirect to admin app
    window.location.assign(url.toString());
    return;
  }
  // Regular user: navigate within my-app
  navigate(getMyAppDashboardUrl(), { replace: true });
}